import { SxProps } from '@mui/material';
import styled from 'styled-components';
import { Flex, Text } from '../../legacy/style';
import { PageTitle } from '../../design_system/texts';

export const Title = PageTitle;

export const tooltipCell: SxProps = {
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.43,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export const EmptyReference = styled(Flex).attrs({ column: true })`
    height: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

export const TextInformation = styled(Text).attrs({ size: '18px' })`
    line-height: 1;
`;
